var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","data-server-rendered":"true"}},[_c('loader',{attrs:{"id":"global"}}),_vm._v(" "),_c('alert'),_vm._v(" "),_c('transition-page',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }